<template lang="pug">
  .layout
    y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")

      v-card(flat)
        v-card-title.pa-0
          v-row.px-5.pt-3.pb-2(v-if="hasChanges" no-gutters align="center" :style="`background-color: ${$vuetify.theme.themes[$theme].success600}`")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.basic100--text {{ $t('save_changes') }}
            v-col.ml-3.shrink
              v-layout
                v-btn.mr-2.my-auto(depressed small outlined color="basic100" @click="clickRevert()")
                  .button-AA-small.basic100--text {{ $t('cancel') }}
                v-btn.my-auto.basic100(depressed small @click="clickSave()" :loading="isLoading")
                  .button-AA-small.primary500--text {{ $t('save') }}
          
          v-row.px-5.pt-3.pb-2(v-else no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.primary500--text {{ $t('order_settings') }}

        v-layout.my-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

        v-card-text.pa-0.pb-12(v-else)
          v-form.mt-4(ref="form")

            v-card.pa-4.mx-4.mt-4(flat style="border:1px solid var(--v-basic400);")
              .s1 {{ $t('scheduling') }}
              .c1.basic600--text {{ $t('scheduling_desc') }}
              v-row(align='center')
                v-col
                  .p2.basic700--text {{ $t('enable_scheduling') }}
                v-col.shrink
                  y-switch.mb-n2.mr-n2(:color="$vuetify.theme.themes[$theme].success400" v-model="enableScheduling")
              
              template(v-if="enableScheduling")
                scheduling(:parentSettings.sync="settings")

            v-card.pa-4.mx-4.mt-4(flat style="border:1px solid var(--v-basic400);")
              .s1 {{ $t('preparation_time') }}
              .c1.basic600--text {{ $t('preparation_time_desc') }}
              v-row(align='center')
                v-col
                  .p2.basic700--text {{ $t('enable_preparation_time') }}
                v-col.shrink
                  y-switch.mb-n2.mr-n2(:color="$vuetify.theme.themes[$theme].success400" v-model="enablePreparationTime")
              
              .enable(v-if="enablePreparationTime")
                v-divider.basic400
                .time.mt-4
                  .p2 {{ $t('how_long_prepare_orders') }}
                  preparation-time.mt-2(:parentSettings.sync="settings")
            
            v-card.pa-4.mx-4.mt-4(flat style="border:1px solid var(--v-basic400);")
              .s1 {{ $t('cut_off_time') }}
              .c1.basic600--text {{ $t('cut_off_time_desc') }} 
              v-row(align='center')
                v-col
                  .p2.basic700--text {{ $t('enable_cut_off_time') }}
                v-col.shrink
                  y-switch.mb-n2.mr-n2(:color="$vuetify.theme.themes[$theme].success400" v-model="enableCutoffTime")
              
              .enable(v-if="enableCutoffTime")
                v-divider.basic400
                cut-off-time.mt-4(:parentSettings.sync="settings")


    .modals
            
</template>

<script>
import { mapActions } from 'vuex'
import Scheduling from '@/components/ordersettings/Scheduling.vue'
import PreparationTime from '@/components/ordersettings/PreparationTime.vue'
import CutOffTime from '@/components/ordersettings/CutOffTime.vue'

export default {
  name: 'OrderSettings',
  components: { Scheduling, PreparationTime, CutOffTime },
  props: ['open', 'company'],
  data: () => ({
    isFetching: false,
    originalSettings: null,
    settings: null,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required'],
      instructions_count: [v => v.length <= 300 || 'Max 300 characters']
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    hasChanges () {
      if (JSON.stringify(this.settings) !== JSON.stringify(this.originalSettings)) {
        return true
      }
      return false
    },
    enableScheduling: {
      get() {
        if (this.settings) {
          return this.settings.scheduling_enabled
        }
        return false
      },
      set(newValue) {
        this.settings.scheduling_enabled  = newValue
      }
    },
    enablePreparationTime: {
      get() {
        if (this.settings) {
          return this.settings.preparation_time_enabled
        }
        return false
      },
      set(newValue) {
        this.settings.preparation_time_enabled  = newValue
        if (newValue && this.settings.preparation_time_value == null) {
          this.settings.preparation_time_value = 30
          this.settings.preparation_time_unit = 'minutes'
        }
      }
    },
    enableCutoffTime: {
      get() {
        if (this.settings) {
          return this.settings.cut_off_time_enabled
        }
        return false
      },
      set(newValue) {
        this.settings.cut_off_time_enabled  = newValue
        if (newValue && this.settings.cut_off_time == null) {
          this.settings.cut_off_time = 30
        }
      }
    }
  },
  mounted () {
    this.fetchOrderSettings()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchOrderSettings() {
      this.isFetching = true
      this.$axios.get(`/oms/${this.company.slug}`)
        .then((response) => {
          this.settings = { ...response.data }
          this.originalSettings = { ...response.data }
          this.isFetching = false
        }).catch(() => {})
    },
    clickRevert () {
      this.settings = { ...this.originalSettings }
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      this.$axios.patch(`/oms/${this.company.slug}`, this.settings)
        .then((response) => {
          this.$emit("edited")
          this.settings = { ...response.data }
          this.originalSettings = { ...response.data }
        }).catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        }).finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "id": {
    "scheduling_desc": "Mengharuskan pelanggan untuk memilih tanggal dan waktu sebelum melakukan pemesanan. Ini akan memungkinkan pelanggan kamu untuk memesan bahkan ketika kamu tutup.",
    "enable_scheduling": "Aktifkan penjadwalan",
    "preparation_time": "Waktu persiapan",
    "preparation_time_desc": "Tentukan waktu yang diperlukan untuk menyiapkan pesanan untuk pengambilan atau pengiriman.",
    "enable_preparation_time": "Aktifkan waktu persiapan",
    "how_long_prepare_orders": "Berapa lama waktu yang dibutuhkan untuk menyiapkan pesanan??",
    "cut_off_time": "Masa Cut-off",
    "cut_off_time_desc": "Ini adalah waktu akhir pesanan akan diproses untuk hari kerja itu.",
    "enable_cut_off_time": "Aktifkan masa cut-off"
  },
  "en": {
    "scheduling_desc": "Require customers to select date and time before placing an order. This will allow your customers to place an order even when you are closed.",
    "enable_scheduling": "Enable scheduling",
    "preparation_time": "Preparation time",
    "preparation_time_desc": "Specify time required to prepare orders for pickup or delivery.",
    "enable_preparation_time": "Enable preparation time",
    "how_long_prepare_orders": "How long does it take to prepare orders?",
    "cut_off_time": "Cut-off time",
    "cut_off_time_desc": "This is the last time an order will be processed for that business day.",
    "enable_cut_off_time": "Enable cut-off time"
  }
}
</i18n>
